import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LogoutDirective } from './directives/logout.directive';
import { MaterialModule } from './material.module';
import { RouterModule } from '@angular/router';
import { MultiStepNavigatorComponent } from './components/multi-step-navigator/multi-step-navigator.component';
import { StepNavigatorComponent } from './components/multi-step-navigator/components/step-navigator/step-navigator.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { FooterComponent } from './components/footer/footer.component';
import { OffScreenMenuComponent } from './components/offscreen-menu/offscreen-menu.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ModalModule } from '../features/modal/modal.module';
import { ArrayToStringPipe } from './pipes/array-to-string.pipe';
import { UncheckDirective } from './directives/uncheck.directive';
import { CheckDirective } from './directives/check.directive';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TooltipInfoComponent } from './components/tooltip-info/tooltip-info.component';
import { EmptyValueDirective } from './directives/empty-value.directive';
import { NgxMaskModule } from 'ngx-mask';
import { ShowControlErrorsModule } from './components/error-container/show-control-errors/show-control-errors.module';
import { FilterPipe } from './pipes/filter.pipe';
import { ChartsModule } from 'ng2-charts';
import { NumberOrDashesPipe } from './pipes/number-or-dashes.pipe';
import { StringOrDashesPipe } from './pipes/string-or-dashes.pipe';
import { TooltipModule } from 'primeng/tooltip';
import { CompetenciaToDatePipe } from './pipes/competencia-to-date.pipe';
import { OverflowTooltipDirective } from './directives/overflow-tooltip.directive';
import { DialogModule } from 'primeng/dialog';
import { LoaderComponent } from '../loader/loader.component';
import { MultiSelectModule } from 'primeng/multiselect';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { MatPaginatorModule } from '@angular/material/paginator';
import { TranslateModule } from '@ngx-translate/core';
import { FooterEvoComponent } from './components/footers/footer-evo/footer-evo.component';
import { FooterSpedComponent } from './components/footers/footer-sped/footer-sped.component';
import { FormatTimePipe } from './pipes/format-time.pipe';
import { ConfirmPopupComponent } from './components/confirm-popup/confirm-popup.component';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { ButtonModule } from 'primeng/button';
import { ConfirmationService } from 'primeng/api';
import { LoadingComponent } from './components/loading/loading.component';
import { ConfirmarAtivarInativarClientesComponent } from './components/confirmar-ativar-inativar-clientes/confirmar-ativar-inativar-clientes.component';

@NgModule({
    declarations: [
        LogoutDirective,
        CheckDirective,
        UncheckDirective,
        MultiStepNavigatorComponent,
        StepNavigatorComponent,
        NavbarComponent,
        FooterComponent,
        FooterEvoComponent,
        FooterSpedComponent,
        OffScreenMenuComponent,
        ArrayToStringPipe,
        TooltipInfoComponent,
        EmptyValueDirective,
        FilterPipe,
        NumberOrDashesPipe,
        StringOrDashesPipe,
        CompetenciaToDatePipe,
        OverflowTooltipDirective,
        LoaderComponent,
        FormatTimePipe,
        ConfirmPopupComponent,
        LoadingComponent,
        ConfirmarAtivarInativarClientesComponent
    ],
    imports: [
        CommonModule,
        MaterialModule,
        RouterModule,
        ReactiveFormsModule,
        MatTooltipModule,
        NgxMaskModule.forRoot(),
        ChartsModule,
        DialogModule,
        MultiSelectModule,
        ScrollPanelModule,
        ButtonModule,
        DialogModule,
        MatPaginatorModule,
        TooltipModule
    ],

    exports: [
        CommonModule,
        MaterialModule,
        ModalModule,
        ReactiveFormsModule,
        LogoutDirective,
        CheckDirective,
        UncheckDirective,
        EmptyValueDirective,
        StepNavigatorComponent,
        MultiStepNavigatorComponent,
        NavbarComponent,
        FooterComponent,
        FooterEvoComponent,
        FooterSpedComponent,
        OffScreenMenuComponent,
        ArrayToStringPipe,
        TooltipInfoComponent,
        NgxMaskModule,
        ShowControlErrorsModule,
        FilterPipe,
        NumberOrDashesPipe,
        StringOrDashesPipe,
        TooltipModule,
        CompetenciaToDatePipe,
        OverflowTooltipDirective,
        DialogModule,
        LoaderComponent,
        MultiSelectModule,
        ScrollPanelModule,
        MatPaginatorModule,
        TranslateModule,
        FormatTimePipe,
        LoadingComponent,
        ConfirmPopupComponent,
        ConfirmarAtivarInativarClientesComponent
    ],


    providers: [
      ConfirmationService
    ]

})
export class SharedModule { }
